module.exports = __webpack_public_path__ + "static/media/20ECE29.9ff92195.jpg";